import { motion } from "motion/react";
import { MessageCircle } from "lucide-react";
import { SectionLabel } from "@/components/common/SectionLabel";
import { SERVICES } from "@/constants/services";
import { CONTACT_INFO } from "@/constants/company";
import { ANIMATION_VARIANTS } from "@/constants/animations";

export function ServicesSection() {
  return (
    <section id="servicios" className="py-[120px] bg-[#A5E0DF]/10">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          variants={ANIMATION_VARIANTS.fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="text-center mb-16"
        >
          <SectionLabel text="Nuestros Servicios" />
          <h2 className="text-4xl font-bold text-[#0A2540] max-w-2xl mx-auto leading-snug mt-2">
            Soluciones técnicas diseñadas para el máximo rendimiento operativo
          </h2>
          <p className="mt-6 text-[16px] md:text-[18px] text-[#0A2540]/75 max-w-2xl mx-auto font-normal leading-[1.7]">
            Cada servicio es desarrollado por especialistas con experiencia
            comprobada, cumpliendo los más altos estándares de calidad y
            normativas vigentes.
          </p>
        </motion.div>

        <motion.div
          variants={ANIMATION_VARIANTS.staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
          className="grid grid-cols-1 md:grid-cols-2 gap-10"
        >
          {SERVICES.map((service) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={service.id}
                variants={ANIMATION_VARIANTS.cardVariant}
                whileHover={{
                  y: -6,
                  boxShadow: "0 20px 48px rgba(10,37,64,0.13)",
                }}
                className="bg-white border border-[#1A3F75]/15 rounded-lg hover:border-[#39B5BF]/60 transition-all shadow-sm flex flex-col h-full group overflow-hidden"
              >
                <div className="h-56 w-full overflow-hidden relative">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-[#0A2540]/30 mix-blend-multiply transition-colors group-hover:bg-[#0A2540]/20" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A2540]/80 via-[#0A2540]/10 to-transparent" />
                  <div className="absolute bottom-5 left-6 w-12 h-12 rounded-lg bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center">
                    <Icon className="w-6 h-6 text-white" strokeWidth={2} />
                  </div>
                </div>

                <div className="p-8 flex flex-col flex-grow">
                  <h3 className="text-2xl font-bold text-[#0A2540] mb-6">
                    {service.title}
                  </h3>
                  <ul className="space-y-4 mb-10 flex-grow">
                    {service.items.map((item, i) => (
                      <li
                        key={i}
                        className="flex items-start gap-4 text-[#0A2540]/80"
                      >
                        <div className="mt-2 w-1.5 h-1.5 rounded-full bg-[#39B5BF] shrink-0" />
                        <span className="text-[16px] font-normal leading-[1.7]">
                          {item}
                        </span>
                      </li>
                    ))}
                  </ul>
                  <a
                    href={`https://wa.me/${CONTACT_INFO.whatsapp.number}?text=${encodeURIComponent(service.whatsappMessage)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-auto w-full flex items-center justify-center gap-2 bg-[#25D366] text-white px-6 py-4 rounded-lg font-bold text-[15px] hover:bg-[#20B45B] transition-all shadow-md hover:shadow-lg"
                  >
                    <MessageCircle className="w-5 h-5" />
                    Cotizar Servicio
                  </a>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}